import { useEffect } from 'react';

// shortcuts: array of { key, ctrl, meta, shift, action, description }
export function useKeyboardShortcuts(shortcuts) {
  useEffect(() => {
    const handler = (e) => {
      for (const shortcut of shortcuts) {
        const ctrlMatch = shortcut.ctrl ? (e.ctrlKey || e.metaKey) : true;
        const shiftMatch = shortcut.shift ? e.shiftKey : true;
        if (ctrlMatch && shiftMatch && e.key.toLowerCase() === shortcut.key.toLowerCase()) {
          // Don't trigger if user is typing in an input/textarea
          const tag = document.activeElement?.tagName;
          if (tag === 'INPUT' || tag === 'TEXTAREA') continue;
          e.preventDefault();
          shortcut.action();
          break;
        }
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [shortcuts]);
}
